import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Home } from './Home';
import { isLang, LanguageProvider } from '../contexts/LanguageContext';
import { Lang } from '../types/content';
interface LanguagePageProps {
  fallback: Lang;
}
export function LanguagePage({
  fallback
}: LanguagePageProps) {
  const {
    lang
  } = useParams();
  if (!isLang(lang)) return <Navigate to={`/${fallback}`} replace data-id="element-289" data-mp="3pif2rkz8x7ga" />;
  return <LanguageProvider lang={lang} data-id="element-290" data-mp="3pgu71s173igu">
      <Home data-id="element-291" data-mp="3pglvc3gt6j78" />
    </LanguageProvider>;
}